<div  *ngIf="display === 'mainSearch'" class="search-container" id="search-bar"
    [ngClass]=" {'headerFixedSearch' : isHeaderSearchClassActive , 'mb-30 searchpagenotfound': !isHeaderSearchClassActive, 'searchbarWithStickyHeader': stripMargin,
    'seach-with-strip' : shouldShowTrialBanner} ">
    <div class="btn-group banner-search" [ngClass]="{ 'mb-0': !isHeaderSearchClassActive }">
        <div class="input-group">
            <input type="text" class="form-control filter-search-bar"
                placeholder="Search tender by Keyword, Category, Authorities..." [(ngModel)]="searchQuery"
                (keyup)="onKeyUp($event)" (keyup.enter)="searchTenders()">
            <span class="cursor">
                <i class="sprite-img search-icon" (click)="searchTenders()"></i>
            </span>
        </div>
        <div *ngIf="dropdownOptions.length" class="autocomplete-dropdown overflow-scroll-1">
            <ul>
                <li *ngFor="let option of dropdownOptions" (click)="navigateToResult(option.searchLink)">
                    <i class="dropdown-search-icon sprite-img-header-footer"></i>
                    <div>
                        <div [innerHTML]="highlightText(option.searchName, searchQuery)"></div>
                        <span class="search-tag">in {{ option.searchTag}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>


<div *ngIf="display !== 'mainSearch'" class="search-container user-preference-search mb-10" id="search-bar"
  >
    <div class="search-group">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="rgba(151,151,151,1)">
            <path
                d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z">
            </path>
        </svg>
        <input placeholder="Type Location, Keyword & Category" type="text" class="form-control"
            placeholder="Search tender by Keyword, Category, Authorities..." [(ngModel)]="searchQuery"
            (keyup)="onKeyUp($event)" (keyup.enter)="searchTenders()">
    </div>
    <div *ngIf="dropdownOptions.length" class="autocomplete-dropdown overflow-scroll-1">
        <ul>
            <li *ngFor="let option of dropdownOptions" (click)="onSearchSelect(option)">
                <i class="dropdown-search-icon sprite-img-header-footer"></i>
                <div>
                    <div [innerHTML]="highlightText(option.searchName, searchQuery)"></div>
                    <span class="search-tag">in {{ option.searchTag}}</span>
                </div>
            </li>
        </ul>
    </div>
</div>